// Melding op het bord als het gezinsbord verwijderd gaat worden (0036). Arabische tegenhanger.
export const kioskPrivacyAr = {
    closingTitle: 'تتوقف هذه اللوحة في {date}',
    closingBody: 'هل هذا غير صحيح؟ اسأل أحد الوالدين: لا يزال بالإمكان إيقاف ذلك في التطبيق.',
};
//# sourceMappingURL=kioskPrivacy.ar.js.map